/* ============================================================
   BEST LOGO MATS™ — Automatic Mockup Email System
   Uses EmailJS to send mockup to client + order@ simultaneously
   
   SETUP (3 minutes):
   1. Go to https://www.emailjs.com — sign up free
   2. Add Email Service → connect your Gmail/Outlook
   3. Create Template (customer) → use template below
   4. Create Template (store) → use template below
   5. Replace the 4 placeholders below with your real IDs
   ============================================================ */

/* ── YOUR EMAILJS CREDENTIALS — replace these 4 values ── */
var BLM_EMAIL_CONFIG = {
  publicKey:          'YOUR_EMAILJS_PUBLIC_KEY',    // Account > API Keys
  serviceId:          'YOUR_SERVICE_ID',            // Email Services tab
  templateCustomer:   'YOUR_CUSTOMER_TEMPLATE_ID',  // Template for client
  templateStore:      'YOUR_STORE_TEMPLATE_ID',     // Template for order@
  storeEmail:         'order@bestlogomats.com'
};

/* ── Load EmailJS SDK ── */
(function(){
  var s = document.createElement('script');
  s.src = 'https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js';
  s.onload = function(){
    if (window.emailjs) {
      emailjs.init({ publicKey: BLM_EMAIL_CONFIG.publicKey });
      console.log('[BLM] EmailJS ready');
    }
  };
  document.head.appendChild(s);
})();

/* ════════════════════════════════════════════════════════════
   MAIN FUNCTION — called on form submit
   Captures canvas, sends both emails, then submits to Shopify
════════════════════════════════════════════════════════════ */
function blmSendMockupEmail(formData, onSuccess, onError) {

  /* Step 1: Capture canvas as PNG */
  var cv = document.getElementById('cv');
  var mockupDataUrl = cv ? cv.toDataURL('image/png', 0.92) : null;

  /* Step 2: Also capture uploaded logo if present */
  var logoDataUrl = null;
  if (window.S && window.S.img && window.S.img.src && window.S.img.src.startsWith('blob:')) {
    /* Convert blob URL to data URL for email */
    try {
      var tmpCanvas = document.createElement('canvas');
      tmpCanvas.width  = window.S.img.naturalWidth;
      tmpCanvas.height = window.S.img.naturalHeight;
      var tCtx = tmpCanvas.getContext('2d');
      tCtx.drawImage(window.S.img, 0, 0);
      logoDataUrl = tmpCanvas.toDataURL('image/png', 0.85);
    } catch(e) {
      logoDataUrl = null;
    }
  }

  if (!window.emailjs) {
    console.warn('[BLM] EmailJS not loaded — falling back to Shopify form');
    onError('EmailJS not ready');
    return;
  }

  var useMap = {indoor:'Indoor',outdoor:'Outdoor',fatigue:'Anti-Fatigue',event:'Event/POP'};
  var total  = (window.S ? window.S.price * window.S.qty : 0);

  /* ── Template params shared across both emails ── */
  var sharedParams = {
    customer_name:    formData.name,
    customer_email:   formData.email,
    customer_phone:   formData.phone   || 'Not provided',
    customer_company: formData.company || 'Not provided',
    mat_product:      window.S ? window.S.nm    : 'Custom Mat',
    mat_use:          window.S ? (useMap[window.S.use]||window.S.use) : '',
    mat_size:         window.S ? window.S.szKey   : '',
    mat_color:        window.S ? window.S.colorName : '',
    mat_qty:          window.S ? window.S.qty   : 1,
    mat_total:        '$' + total,
    artwork_file:     window.S ? (window.S.file || (window.S.fd ? 'Free design requested' : 'To be provided')) : '',
    design_notes:     (document.getElementById('design-notes')||{}).value || 'None',
    order_date:       new Date().toLocaleDateString('en-US',{weekday:'long',year:'numeric',month:'long',day:'numeric'}),
    mockup_image:     mockupDataUrl || '',
    logo_image:       logoDataUrl   || '',
    store_email:      BLM_EMAIL_CONFIG.storeEmail
  };

  var sent = 0;
  var errors = 0;

  function checkDone() {
    if (sent + errors === 2) {
      if (errors === 2) {
        onError('Both emails failed');
      } else {
        onSuccess();
      }
    }
  }

  /* ── Email 1: Customer confirmation with mockup ── */
  emailjs.send(
    BLM_EMAIL_CONFIG.serviceId,
    BLM_EMAIL_CONFIG.templateCustomer,
    Object.assign({}, sharedParams, {
      to_email:    formData.email,
      to_name:     formData.name,
      reply_to:    BLM_EMAIL_CONFIG.storeEmail,
      subject:     'Your Best Logo Mats™ Order Preview — Proof Coming Within 24 Hours'
    })
  ).then(function(){ sent++; checkDone(); })
   .catch(function(err){ console.error('[BLM] Customer email failed:', err); errors++; checkDone(); });

  /* ── Email 2: Store notification with full order details ── */
  emailjs.send(
    BLM_EMAIL_CONFIG.serviceId,
    BLM_EMAIL_CONFIG.templateStore,
    Object.assign({}, sharedParams, {
      to_email:    BLM_EMAIL_CONFIG.storeEmail,
      to_name:     'Best Logo Mats Team',
      reply_to:    formData.email,
      subject:     'NEW ORDER: ' + (window.S ? window.S.nm : 'Custom Mat') + ' | ' + (window.S ? window.S.szKey : '') + ' x' + (window.S ? window.S.qty : '') + ' | $' + total + ' | ' + formData.name
    })
  ).then(function(){ sent++; checkDone(); })
   .catch(function(err){ console.error('[BLM] Store email failed:', err); errors++; checkDone(); });
}

/* ════════════════════════════════════════════════════════════
   HOOK INTO THE ORDER FORM
   Intercepts submit, sends emails, then submits to Shopify
════════════════════════════════════════════════════════════ */
document.addEventListener('DOMContentLoaded', function(){

  var form = document.getElementById('order-form');
  if (!form) return;

  /* Remove existing submit listeners by cloning (safe approach) */
  var newForm = form.cloneNode(true);
  form.parentNode.replaceChild(newForm, form);

  newForm.addEventListener('submit', function(e) {
    e.preventDefault(); /* Always intercept first */

    /* Validate */
    var nm = document.getElementById('f-name');
    var em = document.getElementById('f-email');
    if (!nm || !nm.value.trim()) {
      if(nm){ nm.focus(); nm.style.border='2px solid #dc2626'; }
      return;
    }
    if (!em || !em.value.includes('@')) {
      if(em){ em.focus(); em.style.border='2px solid #dc2626'; }
      return;
    }

    /* Show loading state on button */
    var btn = newForm.querySelector('.order-btn');
    var origText = btn ? btn.innerHTML : '';
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<span style="display:flex;align-items:center;gap:10px">⏳ Sending your mockup...</span>';
    }

    /* Rebuild body (from configurator.js) */
    if (typeof buildBody === 'function') buildBody();

    var formData = {
      name:    nm.value.trim(),
      email:   em.value.trim(),
      phone:   (document.getElementById('f-phone')||{}).value || '',
      company: (document.getElementById('f-co')||{}).value || ''
    };

    /* Try sending emails */
    blmSendMockupEmail(
      formData,
      /* onSuccess */
      function() {
        if (btn) {
          btn.innerHTML = '✅ Mockup Sent! Check your email.';
          btn.style.background = '#16a34a';
        }
        /* Submit to Shopify /contact after a short delay */
        setTimeout(function(){ newForm.submit(); }, 1200);
      },
      /* onError — still submit to Shopify, just without the auto-email */
      function(err) {
        console.warn('[BLM] Email send issue:', err, '— submitting to Shopify anyway');
        if (btn) { btn.disabled = false; btn.innerHTML = origText; }
        newForm.submit();
      }
    );
  });
});
